import React, { useEffect, useState, useRef } from 'react';
import Swiper from 'swiper';
import { Mousewheel } from 'swiper/modules';
import { getIsMute, setIsMute } from "helpers/utils";

import { StoriesSlider, Stories, Story } from './stories-slider-react';
import './stories-slider.scss';
import './main.scss';

export default function StoriesPlayer(props) {
  const { storiesData, onCancel, onButton1Click, onButton2Click, loadIndex, setAsFav, onIndexChange } = props;

  const [isMuted, setIsMuted] = useState(getIsMute());
  const [videoStates, setVideoStates] = useState({});
  const storiesSliderRef = useRef(null);

  const handleVideoLoad = (videoKey) => {
    console.log("Video loading started:", videoKey);
    setVideoStates(prev => ({
      ...prev,
      [videoKey]: { isLoaded: true, isReady: false, isPlaying: false, hasError: false }
    }));
  };

  const handleVideoCanPlay = (videoKey) => {
    console.log("Video can play:", videoKey);
    setVideoStates(prev => ({
      ...prev,
      [videoKey]: { ...prev[videoKey], isReady: true }
    }));
  };

  const handleVideoPlay = (videoKey) => {
    setVideoStates(prev => ({
      ...prev,
      [videoKey]: { ...prev[videoKey], isPlaying: true }
    }));
  };

  const handleVideoError = (videoKey) => {
    console.warn("Video failed to load:", videoKey);
    setVideoStates(prev => ({
      ...prev,
      [videoKey]: { ...prev[videoKey], hasError: true }
    }));
  };

  const openUserStories = (userIndex) => {
    const storiesSlider = storiesSliderRef.current;
    storiesSlider.el.classList.add('stories-slider-in');
    storiesSlider.enable();
    storiesSlider.slideTo(userIndex, 0);
  };

  const onCloseButtonClick = () => {
    const storiesSlider = storiesSliderRef.current;
    storiesSlider.disable();
    storiesSlider.el.classList.add('stories-slider-out');
    onCancel();
  };

  useEffect(() => {
    const storiesSlider = storiesSliderRef.current;
    if (storiesSlider) {
      storiesSlider.el.addEventListener('animationend', () => {
        if (storiesSlider.el.classList.contains('stories-slider-out')) {
          storiesSlider.el.classList.remove('stories-slider-in');
          storiesSlider.el.classList.remove('stories-slider-out');
        }
      });
      openUserStories(loadIndex || 0);
    }
  }, [storiesSliderRef]);

  const toggleMute = () => {
    const mute = !isMuted;
    setIsMuted(mute);
    setIsMute(mute);
  };

  const setFav = (favId) => {
    setAsFav(favId);
  };

  return (
      <>
        {storiesData.length > 0 && (
            <StoriesSlider
                Swiper={Swiper}
                EffectCube={Mousewheel}
                enabled={false}
                autoplayDurationVideo={14000}
                autoplayDurationPhoto={4000}
                onSlidesIndexesChange={(mainIndex) => onIndexChange?.(mainIndex)}
                onStoriesSlider={(instance) => (storiesSliderRef.current = instance)}
                onEnd={() => {
                  storiesSliderRef.current.disable();
                  storiesSliderRef.current.el.classList.add('stories-slider-out');
                  onCancel();
                }}
            >
              {storiesData.map((userStories, userStoriesIndex) => (
                  <Stories key={userStoriesIndex}>
                    {userStories.stories.map((story, storyIndex) => {
                      const videoKey = `${userStoriesIndex}-${storyIndex}`;
                      const videoState = videoStates[videoKey] || {};

                      const showPoster = !videoState.isPlaying && !videoState.hasError;

                      return (
                          <Story
                              key={storyIndex}
                              linkTitle1={userStories.user.linkTitle1}
                              linkTitle2={userStories.user.linkTitle2}
                              avatar={userStories.user.avatar && <img src={userStories.user.avatar} />}
                              name={userStories.user.name}
                              area={userStories.user.area}
                              item={userStories.item}
                              itemIndex={userStories.itemIndex}
                              onButton1Click={onButton1Click}
                              onButton2Click={onButton2Click}
                              favId={userStories.favId}
                              toggleMute={toggleMute}
                              isMuted={isMuted}
                              setFav={setFav}
                              isSetAvailable={!!setAsFav}
                              closeButton
                              onCloseButtonClick={onCloseButtonClick}
                          >
                            {story.video ? (
                                <div className={`video-container ${
                                    videoState.hasError ? '' :
                                        videoState.isPlaying ? 'video-playing' :
                                            videoState.isReady ? 'video-ready' : 'video-loading'
                                }`}>
                                  {story.videoimage && (
                                      <img
                                          src={story.videoimage}
                                          className={`video-poster ${videoState.isPlaying ? 'video-poster-hidden' : ''}`}
                                          alt="Video poster"
                                      />
                                  )}
                                  {!videoState.hasError ? (
                                      <video
                                          src={story.video}
                                          muted={isMuted}
                                          playsInline
                                          preload="metadata"
                                          poster={story.videoimage}
                                          onLoadStart={() => handleVideoLoad(videoKey)}
                                          onCanPlay={() => handleVideoCanPlay(videoKey)}
                                          onPlaying={() => handleVideoPlay(videoKey)}
                                          onError={() => handleVideoError(videoKey)}
                                      />
                                  ) : (
                                      <img src={story.videoimage} alt="Story fallback" />
                                  )}
                                </div>
                            ) : (
                                <img src={story.image} alt="Story" />
                            )}
                          </Story>
                      );
                    })}
                  </Stories>
              ))}
            </StoriesSlider>
        )}
      </>
  );
}
